import { useBaseParam } from '../../application/hooks/useBaseParam';
import { IParams, defaultAxios } from './base';

export interface IFetchSurveyRequest extends IParams {
    type: string;
}

export interface ISurvey {
    surveySeq: number;
    title: string;
    subtitle?: string;
    questions: ISurveyQuestion[];
}

export interface ISurveyQuestion {
    questionSeq: number;
    questionType: string; // 질문타입코드(객관식, 주관식)
    requiredYn: string; // 필수여부
    questionText: string; // 질문
    dependentQuestionSeq: number | null;
    chooseCount: number;

    options: ISurveyQuestionOption[] | null;
}

export interface ISurveyQuestionOption {
    optionSeq: number;
    inputType: string;
    optionText: string;
}

export interface ISurveyAnswer {
    custSeq: number;
    surveySeq: number;
    targetSeq?: number;
    answers: ISurveyQuestionAnswer[]
}

export interface ISurveyQuestionAnswer {
    questionSeq: number;
    textAnswer: string;
    selectedOptions: ISurveyOptionAnswer[]
}

export interface ISurveyOptionAnswer {
    optionSeq: number;
    textAnswer?: string;
    isDirectInput: boolean;
}

export async function postSurvey(answer: ISurveyAnswer) {
    return defaultAxios().post(`/survey/answer`, answer);
}

export async function fetchSurvey(params: IFetchSurveyRequest) {
    return defaultAxios().post(`/survey/question`, params);
};
